import React from 'react';
import Section from '../../Company/Faqs/Section';
import FaqContent from '../../Company/Faqs/FaqContent';
import MetaTags from '../../../helpers/Common/MetaTags';
import { getMetaConfig } from '../../../helpers/Common/metaConfig';

const Faqs = () => {
    const faqsMeta = getMetaConfig('faqs');
    
    return (
        <React.Fragment>
            <MetaTags {...faqsMeta} />
            <Section/>
            <FaqContent/>
        </React.Fragment>
    )
}

export default Faqs;
